import { render } from "./TransactionInventory.vue?vue&type=template&id=21be3db5&scoped=true"
import script from "./TransactionInventory.vue?vue&type=script&lang=js"
export * from "./TransactionInventory.vue?vue&type=script&lang=js"

import "./TransactionInventory.vue?vue&type=style&index=0&id=21be3db5&scoped=true&lang=css"
import "./TransactionInventory.vue?vue&type=style&index=1&id=21be3db5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21be3db5"]])

export default __exports__